import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/app-redux/hooks";
import { Box, Link as MuiLink, Grid, Backdrop } from "@material-ui/core";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { columns } from "./components/columns";
import { searchData } from "src/app-redux/common-actions";
import { useStyles } from "./components/style";
import {
  getPaymentDetailsById,
  getPaymentTypesDropdownAction,
} from "src/app-redux/commercial/actions/commercialActions";
import {
  setSelectedPaymentId,
  selectLoader as commercialLoader,
  setAmountDue,
} from "src/app-redux/commercial/commercialSlice";
import Drawer from "./components/Drawer";
import DrawerVehicleDetails from "src/modules/vehicle-management/pages/ListVehicles/components/Drawer";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { loader as vehicleLoader, setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function PaymentsList({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [paymentRecord, setpaymentRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(commercialLoader);
  const loader3: any = useAppSelector(vehicleLoader);

  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const [isVehicleDrawerOpen, setisVehicleDrawerOpen] = React.useState(false);

  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const handleCloseVehicleDrawer = () => {
    setisVehicleDrawerOpen(false);
  };
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };

  useEffect(() => {
    if (paymentRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "serialNumber"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getPaymentDetailsById(row.original.paymentId));
                        dispatch(
                          setSelectedPaymentId({
                            paymentId: row.original.paymentId,
                            regNo: row.original.registrationNumber,
                          })
                        );
                        dispatch(setAmountDue(row.original.totalPaymentDue));
                        dispatch(getPaymentTypesDropdownAction());
                        setisDrawerOpen(true);
                      }}
                    >
                      {row.original.serialNumber ? row.original.serialNumber : "-"}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "registrationNumber"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <MuiLink
                    className="customMuiLink"
                    onClick={() => {
                      dispatch(getVehicleDetailsByIdAction(row.original.gatePassId));
                      dispatch(setSelectedVehicleId(row.original.gatePassId));
                      setisVehicleDrawerOpen(true);
                    }}
                  >
                    {row.original.registrationNumber}
                  </MuiLink>
                );
              },
            }
          : column.accessorKey === "vehicleStatus"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <>
                    <Box className={`${renderedCellValue === "Checked-out" ? "label-green" : ""}`}>
                      {renderedCellValue}
                    </Box>
                  </>
                );
              },
            }
          : column.accessorKey === "totalPayment"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original.currency.toUpperCase() || "PKR "
                } ${row.original.totalPayment.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}`;
              },
            }
          : column.accessorKey === "totalPaymentReceived"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original.currency.toUpperCase() || "PKR "
                } ${row.original.totalPaymentReceived.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}`;
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [paymentRecord]);

  const formik = useFormik({
    initialValues: {
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      deletedPaymentDataOnly: true,
    },
    onSubmit: () => {
      // handleSearch();
    },
  });
  const { values, setValues } = formik;

  const compareByDeletedDate = (a: any, b: any) => {
    const dateA = new Date(a.deletedAt);
    const dateB = new Date(b.deletedAt);

    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    } else {
      const timeA = new Date(a.deletedAt).getTime();
      const timeB = new Date(b.deletedAt).getTime();
      if (timeA < timeB) {
        return 1;
      } else if (timeA > timeB) {
        return -1;
      } else {
        return 0;
      }
    }
  };

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, deletedPaymentDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      deletedPaymentDataOnly: deletedPaymentDataOnly || true,
    };
    setpaymentRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-deleted-payments", JSON.stringify(body))
      );
      const apiRecord = results;
      if (apiRecord) {
        apiRecord.sort(compareByDeletedDate);
        const transformedData = apiRecord.map((data: any) => {
          return { ...data, id: data.paymentId ? data.paymentId : Math.random() };
        });
        setpaymentRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  const [resetHandler, setResetHandler] = useState(false);

  const resetSearch = () => {
    setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2 || loader3}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />

      {!loader3 && (
        <DrawerVehicleDetails
          isDrawerOpen={isVehicleDrawerOpen}
          handleCloseDrawer={() => {
            handleCloseVehicleDrawer();
          }}
        />
      )}

      <Grid spacing={2} container direction="row">
        <Grid item xs={12} md={3} lg={3}>
          <CommonAutoCompleteField
            cssClassName="customTextField"
            error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
            helperText={formik.touched.filterBy && formik.errors.filterBy}
            label="Filter by"
            placeholder="Filter by"
            name="filterBy"
            disableClearable={true}
            optionsType={filteryByArr}
            getOptionLabel={(option: any) => option.label || null}
            onChange={(row: any) => {
              row ? setValues({ ...values, filterBy: row.value || "" }) : "";
              if (row === null) {
                formik.setFieldValue("filterBy", null);
              }
              filterByAction(row);
            }}
            value={filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} className={!isCustomDate ? classes.hideDatesGrid : ""}>
          <CommonTextFieldDate
            cssClassName="customTextField"
            label={"Start Date"}
            name={"startDate"}
            datePickerRef={startDatePickerRef}
            value={formik.values.startDate}
            onChange={(e: any) => {
              formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
              formik.setFieldValue("endDate", "");
            }}
            maxDate={moment().format("YYYY-MM-DDTHH:mm")}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} className={!isCustomDate ? classes.hideDatesGrid : ""}>
          <CommonTextFieldDate
            cssClassName="customTextField"
            label={"End Date"}
            name={"endDate"}
            datePickerRef={endDatePickerRef}
            value={formik.values.endDate}
            onChange={(e: any) => {
              formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
            }}
            minDate={formik.values.startDate}
            maxDate={moment().format("YYYY-MM-DDTHH:mm")}
          />
        </Grid>

        <Grid item xs={12} md={isCustomDate ? 12 : 3} lg={isCustomDate ? 3 : 9}>
          <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
            <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
              Reset
            </CommonButton>
            <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
              Search
            </CommonButton>
          </Box>
        </Grid>
      </Grid>

      <CommonMaterialGrid
        rows={paymentRecord}
        columns={displayColumns}
        loader={loader}
        defaultPerPageRecord={15}
        height={550}
      />
    </>
  );
}
